import React from 'react';
import { DocumentWithDownloadUrl as Document } from '@/client';
import ViewerFullScreenDialog from '@/components/documents/viewers/ViewerFullScreenDialog.tsx';
import { usePdfViewer } from '@/hooks/viewers/usePdfViewer.ts';

interface SourceFullscreenPreviewProps {
	document: Document;
	page: number;
	onClose: () => void;
}

const SourceFullscreenPreview: React.FC<SourceFullscreenPreviewProps> = ({ document, page, onClose }) => {
	const {
		numPages,
		pageNumber,
		loading,
		pdfOptions,
		onDocumentLoadSuccess,
		onDocumentLoadError,
		goToPrevPage,
		goToNextPage,
		handlePageNumberChange,
		setPageChangeReason,
	} = usePdfViewer({
		fileUrl: document.download_url ?? '',
		isOpen: true,
		initialPage: page,
	});

	if (!document.download_url) return null;

	return (
		<ViewerFullScreenDialog
			title={document.filename}
			isOpen={true}
			onClose={onClose}
			pageNumber={pageNumber}
			numPages={numPages}
			loading={loading}
			pdfOptions={pdfOptions}
			onDocumentLoadSuccess={onDocumentLoadSuccess}
			onDocumentLoadError={onDocumentLoadError}
			goToPrevPage={goToPrevPage}
			goToNextPage={goToNextPage}
			onPageChange={handlePageNumberChange}
			setPageChangeReason={setPageChangeReason}
			showAllPages
		/>
	);
};

export default SourceFullscreenPreview;
